import React from "react";

import { css, keyframes } from "@emotion/css";
import Img1 from "../../../img/png/blog/img1.png";
import Img2 from "../../../img/svg/blog/block-2-bg.svg";
import Img3 from "../../../img/png/blog/img3.png";
import BtnHow from "../../../img/png/blog/btn-how.png";
import BtnGo from "../../../img/png/blog/btn-go.png";
import BtnGoM from "../../../img/png/blog/btn-go-m.png";
import ArrowIcon from "../../../img/svg/blog/arrow-up.svg";
import PosterImg from "../../../img/jpg/blog-video-poster.jpg";
import {
  desktop,
  desktopBig,
  laptop,
  mobile,
  tablet,
} from "../../../styles/breakpoints";
import { Link } from "react-router-dom";
import { useI18n } from "../../../i18n";

const Block1Component = ({ isDesktopBig = true }) => {
  const { t } = useI18n();
  return (
    <div className={`block-1 ${isDesktopBig ? "desktop-big" : "desktop"}`}>
            <Link to={"/post/fit-check-101-the-4-secrets-to-always-slaying-your-look"}>
      <img src={Img1} alt="" />
      <img src={Img1} alt="" className="big" />
      <h3>
        {t("blog_hero_title1")}
        <img src={ArrowIcon} alt="" />
      </h3>
        </Link>
    </div>
  );
};

const AnimationTop = () => {
  return (
    <div className="hashtags">
      <div>
        <span>BODY · IDENTITY · COLOUR · ARCHETYPE · FIT · PROPORTION · FASHION · CHOICE · WARDROBE · STYLE</span>
      </div>
    </div>
  );
};

const AnimationBottom = () => {
  return (
    <div className="hashtags">
      <div>
        <span>STYLE · WARDROBE · CHOICE · FASHION · PROPORTION · FIT · ARCHETYPE · COLOUR · IDENTITY · BODY</span>
      </div>
    </div>
  );
};

const Hero = () => {
  const { t } = useI18n();
  return (
    <div style={{ position: "relative", overflow: "hidden" }}>
      <div className={style.hero}>
        <Block1Component />
        <div className="blocks">
          <Link
            className="block-2"
            to="/post/never-struggle-again-find-your-perfect-outfit-easily-and-unlock-your-style-4"
          >
            <img src={Img2} alt={t("blog_hero_desc")} />
          </Link>
          <div className="block-3">
            <Link to={"/post/the-power-of-ai-in-fashion-how-personalized-shopping-is-winning-over-gen-z"}>
            <img src={Img3} alt="" />
            <img src={Img3} alt="" className="big" />
            <h3>
              {t("blog_hero_title2")}
              <img src={ArrowIcon} alt="" />
            </h3>
            </Link>
          </div>
          <Block1Component isDesktopBig={false} />
        </div>
        <div className="block-4">
          <video autoPlay loop muted playsInline webkit-playsinline poster={PosterImg}>
            <source
              src="/videos/blog_hero_animation.mp4"
              type="video/mp4"
            />
          </video>
          <Link className={"how"} to={"/technology"}>
            <img src={BtnHow} alt={t("blog_hero_how")} />
          </Link>
          <Link className={"get"} to={"/subscribe"}>
            <img src={BtnGo} className="desktop" alt={t("blog_hero_start")} />
            <img src={BtnGoM} className="mobile" alt={t("blog_hero_start")} />
          </Link>
        </div>
      </div>
      <div className={style.slider}>
        <div className="slider left">
          <ul>
            <li>
              <AnimationTop />
            </li>
          </ul>
          <ul aria-hidden="true">
            <li>
              <AnimationTop />
            </li>
          </ul>
        </div>
        <div className="slider right">
          <ul>
            <li>
              <AnimationBottom />
            </li>
          </ul>
          <ul aria-hidden="true">
            <li>
              <AnimationBottom />
            </li>
          </ul>
        </div>
        <div className="slider left mobile">
          <ul>
            <li>
            <AnimationTop />
            </li>
          </ul>
          <ul aria-hidden="true">
            <li>
            <AnimationTop />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

const animation = keyframes({
  to: { transform: "translateX(-100%)" },
});

const animationRight = keyframes({
  from: { transform: "translateX(-100%)" },
});

const style = {
  slider: css({
    marginTop: 30,
    overflowX: "clip",
    height: 160,
    position: "relative",

    ".slider": {
      overflow: "hidden",
      userSelect: "none",
      display: "flex",
      gap: 0,
      position: "absolute",
      marginLeft: -50,
      marginRight: -50,

      ".hashtags": {
        display: "flex",
        gap: 10,

        div: {
          borderRadius: 13.2,
          background: "#FEFBF9",
          padding: "15.4px 19.8px",

          span: {
            color: "#000",
            textAlign: "center",
            fontFamily: "Inter",
            fontSize: 19.8,
            fontStyle: "normal",
            fontWeight: 400,
            letterSpacing: 0.396,
            justifyContent: "center",
            alignItems: "center",
            opacity: 0.5,
          },
        },
      },

      "&.mobile": {
        display: 'none'
      },
      "&.right": {
        top: 70,

        ul: {
          animation: `${animationRight} 15s linear infinite`,
        },
      },

      ul: {
        listStyle: "none",
        flexShrink: 0,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 10,
        animation: `${animation} 15s linear infinite`,
      },
    },

    [desktop]: {
      marginTop: 60,
      ".slider": {

      },
    },
    [laptop]: {
      height: 200,
      marginTop: 70,
      ".slider": {

        ".hashtags": {
          div: {
            padding: '13.297px 17.096px',

            span: {
              fontSize: 17,
            },
          },
        },
        "&.mobile": {
          display: 'flex',
          top: 120 ,
        },
        "&.right": {
          top: 60,
        },
      },
    },
    [tablet]: {
      height: 200,
      marginTop: 60,
      ".slider": {

        ".hashtags": {
          div: {
            padding: '12.307px 15.823px',


            span: {
              fontSize: 15,
            },
          },
        },
        "&.mobile": {
          display: 'flex',
          top: 120 ,
        },
        "&.right": {
          top: 60,
        },
      }
    },
  }),
  hashtag: css({
    width: 2500,
    height: "auto",
    margin: "auto",

    "&.desktop": {
      display: "block !important",
    },
    "&.mobile": {
      display: "none !important",
    },

    [laptop]: {
      width: 1023,
      "&.desktop": {
        display: "none !important",
      },
      "&.mobile": {
        display: "block !important",
      },
    },
  }),
  hero: css({
    marginTop: 110,
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    gap: 10,
    marginBottom: 100,
    maxWidth: 1780,
    marginLeft: "auto",
    marginRight: "auto",

    ".desktop-big": {
      display: "flex !important",
    },
    ".desktop": {
      display: "none !important",
    },

    h3: {
      position: "absolute",
      borderRadius: 90,
      background: "rgba(0, 0, 0, 0.20)",
      padding: "24px 36px",
      color: "#fff",
      fontFamily: "Syne",
      fontSize: 55,
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "60.639px",
      bottom: 40,
      left: 0,
      right: 0,
      margin: "auto",
      width: "fit-content",
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
      gap: 30,
      zIndex: 1,

      img: {
        opacity: "1 !important",
        position: "relative !important",
        width: "100%",
        height: "auto",
        left: "unset !important",
        top: "unset !important",
      },
    },
    ".block-1": {
      borderRadius: 136.758,
      width: 813.711,
      height: 914,
      overflow: "hidden",
      position: "relative",
      backgroundColor: "#A8EF12",

      h3: {
        img: {
          width: 27.078,
          height: 27.078,
          left: "unset !important",
          top: "unset !important",
        },
      },

      "&:hover": {
        img: {
          opacity: 0,

          "&.big": {
            opacity: 1,
          },
        },
      },
      img: {
        width: "auto",
        height: 1200,
        transition: "all 1s",
        opacity: 1,
        top: 0,
        left: "-270px",
        position: "absolute",

        "&.big": {
          opacity: 0,
          scale: 1.2,
        },
      },
    },
    ".blocks": {
      height: 914,
      width: 722,
      gap: 5,

      ".block-3": {
        borderRadius: 60,
        width: 722,
        height: 400,
        overflow: "hidden",
        position: "relative",
        backgroundColor: "#FE42FF",

        img: {
          width: "auto",
          transition: "all 1s",
          opacity: 1,
          top: -50,
          left: "-200px",
          position: "absolute",

          "&.big": {
            opacity: 0,
            scale: 1.2,
          },
        },

        "&:hover": {
          img: {
            opacity: 0,

            "&.big": {
              opacity: 1,
            },
          },
        },
      },
      div: {
        position: "relative",

        h3: {
          padding: "12px 18px",
          fontSize: 26.604,
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "26.494px",
          bottom: 20,
          gap: 15,
          img: {
            width: 13,
            height: 13,
          },
        },
      },
    },
    ".block-4": {
      borderRadius: 60,
      width: 637,
      height: 914,
      overflow: "hidden",
      position: "relative",

      ".overlay": {
        background: 'linear-gradient(0deg, rgba(164, 132, 255, 0.30) 0%, rgba(164, 132, 255, 0.30) 100%), #d9d9d900',
        backgroundBlendMode: 'plus-darker',
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%'
      },
      ".desktop": {
        display: "flex !important",
      },
      ".mobile": {
        display: "none !important",
      },

      video: {
        width: "100%",
        height: "105%",
        objectFit: "cover",
        marginTop: "-10px",
      },
      a: {
        position: "absolute",
        bottom: 30,
        right: 30,

        img: {
          width: "100%",
          height: "auto",
        },
        "&.how": {
          bottom: 100,
        },
      },
    },
    [desktopBig]: {
      marginLeft: 40,
      marginRight: 40,

      ".desktop-big": {
        display: "none !important",
      },
      ".desktop": {
        display: "flex !important",
      },

      ".blocks": {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        alignContent: "space-between",
        justifyContent: "space-between",
        alignItems: "center",

        ".block-1, .block-3": {
          overflow: "hidden",
          width: 357,
          height: 401,
          borderRadius: 60,
          display: "flex",
          flexWrap: "nowrap",
          flexDirection: "column",
          alignContent: "center",
          justifyContent: "center",
          alignItems: "center",

          img: {
            width: "auto",
            height: 600,
            left: 0,
          },

          h3: {
            padding: "12px 18px",
            fontSize: 26.604,
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "26.494px",
            bottom: 20,
            gap: 15,

            img: {
              width: 13,
              height: 13,
            },
          },
        },
        ".block-1": {
          img: {
            height: 600,
            left: -120,
          },
        },
        ".block-3": {
          img: {
            height: 1100,
            left: -380,
          },
        },
      },
    },
    [desktop]: {
      marginLeft: 30,
      marginRight: 30,
      gap: 5,

      ".block-4": {
        width: "100%",
        height: 671,

        a: {
          bottom: 20,
          right: 25,

          img: {
            width: 200,
          },
          "&.how": {
            bottom: 70,
          },
        },
      },
      ".blocks": {
        width: 530.05,
        height: "auto",

        ".block-2": {
          width: 530.01,
          height: 370.71,
          position: "relative",
          img: {
            width: 530.01,
            height: 370.71,
          },
          ".text": {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 8,
            h3: {
              color: "#000",
              textAlign: "center",
              fontFamily: "Syne",
              fontSize: 55,
              fontWeight: 700,
              lineHeight: "55px",
            },
            p: {
              color: "#000",
              textAlign: "center",
              fontFamily: "Inter",
              fontSize: 20,
              fontWeight: 400,
              lineHeight: "27px",
              maxWidth: 480,
            },
          },
        },
        ".block-1, .block-3": {
          width: 262.09,
          height: 294.39,

          img: {
            left: 0,
          },

          h3: {
            padding: "9px 13px",
            fontSize: 19.5,
            lineHeight: "19.5px",
            bottom: 15,
            gap: 9,

            img: {
              width: 10,
              height: 10,
            },
          },
        },
        ".block-1": {
          img: {
            height: 400,
            left: -60,
          },
        },
        ".block-3": {
          img: {
            height: 800,
            left: -280,
          },
        },
      },
    },
    [laptop]: {
      flexDirection: "column-reverse",
      marginTop: 100,
      marginLeft: 30,
      marginRight: 30,
      gap: 5,

      ".block-4": {
        width: "100%",
        height: 916.83,

        ".mobile": {
          display: "flex !important",
        },
        ".desktop": {
          display: "none !important",
        },

        a: {
          bottom: 30,
          right: 25,

          img: {
            width: "auto",
            height: 54,
          },
          "&.how": {
            bottom: 90,
          },
        },
      },
      ".blocks": {
        width: "100%",
        height: "auto",
        ".block-2": {
          width: "100%",
          height: "auto",
          position: "relative",
          img: {
            width: "100%",
            height: "auto",
          },
          ".text": {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 8,
            h3: {
              color: "#000",
              textAlign: "center",
              fontFamily: "Syne",
              fontSize: 36,
              fontWeight: 700,
              lineHeight: "38px",
            },
            p: {
              color: "#000",
              textAlign: "center",
              fontFamily: "Inter",
              fontSize: 16,
              fontWeight: 400,
              lineHeight: "22px",
              maxWidth: "90%",
            },
          },
        },
        ".block-1, .block-3": {
          width: "49.5%",
          height: 450,

          h3: {
            padding: "12px 18px",
            fontSize: 25,
            lineHeight: "25px",
            bottom: 15,
            gap: 12,

            img: {
              width: 13,
              height: 13,
            },
          },
        },
        ".block-1": {
          img: {
            height: 600,
            left: -100,
          },
        },
        ".block-3": {
          img: {
            height: 1100,
            left: -380,
          },
        },
      },
    },
    [tablet]: {
      marginTop: 80,
      marginLeft: 20,
      marginRight: 20,

      ".block-4": {
        height: 450,
        a: {
          bottom: 25,
          right: 25,

          img: {
            width: "auto",
            height: 44,
          },
          "&.how": {
            bottom: 70,
          },
        },
      },
      ".blocks": {
        ".block-1, .block-3": {
          height: 300,
          width: "49%",
          borderRadius: 30,

          h3: {
            padding: "8px 13px",
            fontSize: 12.37,
            lineHeight: "12.37px",
            bottom: 10,
            gap: 8,

            img: {
              width: 9,
              height: 9,
            },
          },
        },
        ".block-1": {
          img: {
            height: 400,
            left: -80,
          },
        },
        ".block-3": {
          img: {
            height: 800,
            left: -280,
          },
        },
      },
    },
    [mobile]: {
      ".blocks": {
        ".block-1": {
          height: 186,
          img: {
            top: 10,
            height: 200,
            left: -20,
          },
        },
        ".block-3": {
          height: 186,
          img: {
            top: -10,
            height: 400,
            left: -120,
          },
        },
      },
    }
  }),
};

export default Hero;
